import { LegalLayout, Section } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="June 26, 2026">
      <div data-testid="privacy-page" className="space-y-8">
        <p className="text-sm text-slate-300 leading-relaxed">
          This Privacy Policy explains how Entrepreneur OS ("ECO", "we", "us") collects, uses and protects your
          information when you use our platform (the "Service"). By using the Service, you agree to this policy.
        </p>

        <Section title="1. Information We Collect">
          <p>• <strong>Account information:</strong> your name, email address, and (if you sign in with Google) your
            profile picture.</p>
          <p>• <strong>Usage data:</strong> lessons completed, streaks, assessment results, challenge progress and
            similar activity used to power your dashboard and recommendations.</p>
          <p>• <strong>Content you submit:</strong> messages to the AI mentor, goals, and documents or text you upload
            to tools such as the Deal Analyzer.</p>
          <p>• <strong>Payment information:</strong> handled by Stripe. We do not store your full card details.</p>
        </Section>

        <Section title="2. How We Use Your Information">
          <p>We use your information to provide and personalize the Service, generate AI responses and analyses, track
            your learning progress, process payments and subscriptions, secure your account, and communicate with you
            (for example, password resets and important account notices).</p>
        </Section>

        <Section title="3. AI Processing">
          <p>To generate mentoring, lessons and document analyses, the content you submit (including text and uploaded
            documents or images) is sent to our AI provider, Anthropic, for processing. We store the resulting analysis
            and basic metadata (such as the file name), but we do not permanently store the raw files you upload.
            Please avoid submitting highly sensitive personal or confidential information.</p>
        </Section>

        <Section title="4. Payments">
          <p>Subscription payments are processed by Stripe, which handles your card data under its own security
            standards and privacy policy. We receive limited transaction details (such as status and amount) to manage
            your subscription.</p>
        </Section>

        <Section title="5. Cookies & Sessions">
          <p>We use a secure session cookie to keep you signed in. We do not use third-party advertising trackers.</p>
        </Section>

        <Section title="6. How We Share Information">
          <p>We do <strong>not</strong> sell your personal information. We share data only with service providers that
            help us run the Service (such as Stripe, Anthropic and Google sign-in), and where required by law.</p>
        </Section>

        <Section title="7. Data Retention">
          <p>We retain your account and usage data while your account is active. You may request deletion of your
            account and associated data by contacting us.</p>
        </Section>

        <Section title="8. Your Rights">
          <p>Depending on your location, you may have rights to access, correct, export or delete your personal data,
            or to object to certain processing. To exercise these rights, email us and we will respond within a
            reasonable time.</p>
        </Section>

        <Section title="9. Security">
          <p>We use industry-standard measures (including encrypted connections and hashed passwords) to protect your
            data. No system is perfectly secure, so we cannot guarantee absolute security.</p>
        </Section>

        <Section title="10. Children">
          <p>The Service is not intended for children under 16. We do not knowingly collect data from children.</p>
        </Section>

        <Section title="11. Changes to This Policy">
          <p>We may update this policy from time to time. Material changes will be posted here with an updated date.</p>
        </Section>

        <Section title="12. Contact">
          <p>For privacy questions or requests, contact us at{" "}
            <a href="mailto:ecoentrepreneuros@gmail.com" className="text-[#4d8bff] hover:underline">ecoentrepreneuros@gmail.com</a>.</p>
        </Section>
      </div>
    </LegalLayout>
  );
}
